import { render, staticRenderFns } from "./ModalReportAccess.vue?vue&type=template&id=5a16ca7f"
import script from "./ModalReportAccess.vue?vue&type=script&lang=js"
export * from "./ModalReportAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports